// The maximum number of brand lists for an account
export const BRAND_LIST_MAX_COUNT = 20;

// The maximum number of brand lists associations
export const BRAND_LIST_SELECTED_OPTIONS_LIMIT = 20;

// The maximum number of brand lists to display in the dropdown
export const BRAND_LIST_OPTIONS_DISPLAY_LIMIT = 20;

// The maximum number of brands for a brand list
export const BRAND_SELECTED_OPTIONS_LIMIT = 100;

// The maximum number of brands to display in the dropdown
export const BRAND_OPTIONS_DISPLAY_LIMIT = 50;

export const DO_NOT_ASK_AGAIN_PREFERENCE_NAME = 'DO_NOT_ASK_AGAIN_SAVE_BRAND_LIST';

export const MT_ALLOWED_MIN_SEARCH_FILTER_LENGTH = 2;

export const ABOUT_BRAND_LISTS_LINK = 'https://help.ads.microsoft.com/#apex/ads/en/60219/0';
